export default "__VITE_ASSET__acda7ad1__"